import { useAccountStore } from '@/stores/account/AccountStore';
import { useAuthenticationStore } from '@/stores/authentication/AuthenticationStore';
import { useExhibitorStore } from '@/stores/exhibitor/ExhibitorStore';
import { useListingStore } from '@/stores/listing/ListingStore';
import { useModeStore } from '@/stores/mode/ModeStore';
import { useSalesAgreementStore } from '@/stores/sales-agreement/SalesAgreementStore';
import { useWhiteLabelStore } from '@/stores/white-label/WhiteLabelStore';
import { usePurchaseRequestsStore } from '@/stores/purchase-requests/PurchaseRequestsStore';

/**
 * StoreManager provides centralized management of store operations
 * that affect multiple stores or require coordination between stores.
 */

/**
 * Resets all stores to their initial state
 */
export const resetAllStores = () => {
  useAccountStore().reset();
  useAuthenticationStore().reset();
  useExhibitorStore().reset();
  useListingStore().reset();
  useModeStore().reset();
  usePurchaseRequestsStore().reset();
  useSalesAgreementStore().reset();
  useWhiteLabelStore().reset();
};
